import React, {useCallback, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from 'react-i18next';
import { notificationSelector, hideNotification } from '../../../slices/NotificationSlice';

const NotificationComponent = React.memo((props) => {

    const dispatch = useDispatch();
    const {message, isShow, duration, type} = useSelector(notificationSelector);
    let notifyTimeout;

    useEffect(() => {
        if (isShow) {
            notifyTimeout = setTimeout(() => {
                close();
            }, duration * 1000);
        }
    }, [isShow]);

    const close = useCallback(() => {
        dispatch(hideNotification())
        if (notifyTimeout) {
            clearTimeout(notifyTimeout)
        }
    }, [dispatch])

    const notificationClass = type.toLocaleLowerCase();

    return (
        isShow &&
        <div className="notification-component">
            <div className={`box ${notificationClass}`}>
                <i className='fal fa-info-circle icon' />
                <span className='content'>
                    {message}
                </span>
                <i className="fal fa-times close" onClick={close}></i>
            </div>
        </div>
    )
});

export default translate([], {wait: true})(NotificationComponent);


// WEBPACK FOOTER //
// ./src/app/components/CompactView/NotificationComponent/index.js